<script setup lang="ts">
  import type { CalendarGridEvent } from '@/types/calendar/grid'
  import {
    calendarEventTypeLine,
    type CalendarEventTypeLabels
  } from '@/utils/calendar/event-display'
  import { computed } from 'vue'

  interface CalendarChipEvent {
    title: string
    type: CalendarGridEvent['type']
    locationText?: string
  }

  const props = defineProps<{
    event: CalendarChipEvent
    eventTypeLabels: CalendarEventTypeLabels
  }>()

  const typeLabel = computed(() => calendarEventTypeLine(props.event.type, props.eventTypeLabels))
</script>

<template>
  <div class="flex min-w-0 flex-col">
    <span
      v-if="typeLabel"
      class="text-muted-foreground-1 block w-full truncate text-[11px] leading-tight"
    >
      {{ typeLabel }}
    </span>
    <span class="block w-full truncate font-medium leading-tight">{{ event.title }}</span>
    <span
      v-if="event.locationText"
      class="text-muted-foreground-1 block w-full truncate text-[11px] leading-tight"
    >
      {{ event.locationText }}
    </span>
  </div>
</template>
